<template>
    <div>
        <div class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                {{ isEditing ? 'Editar Usuário' : 'Cadastrar Usuário' }}
                                <span class="required_fields text-white">
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <div class="row">
                                    <div class="col-md-10">
                                        <form @submit.prevent="save">
                                            <!-- Informações Básicas -->
                                            <UserBasicInfo
                                                v-model="userData"
                                                :errors="errors"
                                                @update="updateUserData"
                                            />

                                            <!-- Informações de Contato -->
                                            <UserContactInfo
                                                v-model="userData"
                                                :errors="errors"
                                                @update="updateUserData"
                                            />

                                            <!-- Informações de Motorista/CNH -->
                                            <UserDriverInfo
                                                v-model="userData"
                                                :errors="errors"
                                                @update="updateUserData"
                                            />

                                            <!-- Informações do Sistema -->
                                            <UserSystemInfo
                                                v-model="userData"
                                                :cost-centers="cost_centers"
                                                :is-editing="isEditing"
                                                :current-user-level="$store.state.user.access_nivel"
                                                :errors="errors"
                                                @update="updateUserData"
                                            />

                                            <!-- Informações de Senha (condicional) -->
                                            <UserPasswordSection
                                                v-if="shouldShowPasswordFields"
                                                v-model="userData"
                                                :is-editing="isEditing"
                                                :errors="errors"
                                                @update="updateUserData"
                                            />

                                            <!-- Botões de Ação -->
                                            <div class="form-actions">
                                                <router-link
                                                    to="/users"
                                                    class="btn btn-back"
                                                >
                                                    <i class="fa fa-arrow-left mr-2"></i>
                                                    Voltar
                                                </router-link>

                                                <button
                                                    type="submit"
                                                    class="btn btn-add"
                                                    :disabled="isLoading"
                                                >
                                                    <i
                                                        class="fa fa-spinner fa-spin mr-2"
                                                        v-if="isLoading"
                                                    ></i>
                                                    <i
                                                        class="fa fa-save mr-2"
                                                        v-else
                                                    ></i>
                                                    {{ isLoading ? 'Salvando...' : 'Salvar' }}
                                                </button>
                                            </div>
                                        </form>
                                    </div>

                                    <!-- Upload de Foto -->
                                    <div class="col-md-2">
                                        <UserPhotoUpload
                                            v-model="userData"
                                            :preview-image="previewImage"
                                            @upload-image="handleImageUpload"
                                            @update="updateUserData"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading Overlay -->
        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {getMessage} from "../../composables/message";

import UserBasicInfo from './form-components/UserBasicInfo.vue';
import UserContactInfo from './form-components/UserContactInfo.vue';
import UserDriverInfo from './form-components/UserDriverInfo.vue';
import UserSystemInfo from './form-components/UserSystemInfo.vue';
import UserPasswordSection from './form-components/UserPasswordSection.vue';
import UserPhotoUpload from './form-components/UserPhotoUpload.vue';
import {convertDateToIso} from "../../composables/functions";

export default {
    name: 'UserForm',
    components: {
        Loading,
        UserBasicInfo,
        UserContactInfo,
        UserDriverInfo,
        UserSystemInfo,
        UserPasswordSection,
        UserPhotoUpload,
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,

            previewImage: null,
            errors: {},

            userData: {
                name: "",
                matriculation: "",
                rg: "",
                cpf: "",

                email: "",
                cellphone: "",

                date_of_birth: "",
                admission_date: "",
                e_date_of_birth: "",
                e_admission_date: "",

                number_cnh: "",
                validity_cnh: "",
                pri_cnh: "",
                e_pri_cnh: "",

                access_nivel: "1",
                cost_center_id: null,
                erp_code: "",

                is_approver: false,
                simplified_checklist: false,
                telemetry: false,
                is_executive: false,

                password: "",
                password_confirmation: "",
                passwordEdit: "",

                photo: null,
                id: null,
            },

            cost_centers: [],
        };
    },
    computed: {
        isEditing() {
            return !!this.$route.params.id;
        },

        shouldShowPasswordFields() {
            return this.userData.email &&
                (this.userData.email.indexOf('innovareti.com.br') > -1 || this.userData.email === 'integracoes.ti@copacol.com.br');
        }
    },
    methods: {
        updateUserData(field, value) {
            this.$set(this.userData, field, value);
        },

        handleImageUpload(previewImage) {
            this.previewImage = previewImage;
        },

        async getCostCenters() {
            try {
                const api = this.$store.state.api + 'cost-centers?paginated=false';
                const response = await this.$http.get(api);
                this.cost_centers = response.data.data;
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            }
        },

        makeFormData() {
            const fd = new FormData();
            const photo = document.getElementById("userPic");

            fd.append("name", this.userData.name || '');
            fd.append("matriculation", this.userData.matriculation || '');
            fd.append("rg", this.userData.rg || '');
            fd.append("cpf", this.userData.cpf || '');
            fd.append("email", this.userData.email || '');
            fd.append("cellphone", this.userData.cellphone || '');
            fd.append("date_of_birth", convertDateToIso(this.userData.date_of_birth));
            fd.append("admission_date", convertDateToIso(this.userData.admission_date));

            fd.append("number_cnh", this.userData.number_cnh || '');
            fd.append("validity_cnh", convertDateToIso(this.userData.validity_cnh));
            fd.append("pri_cnh", convertDateToIso(this.userData.pri_cnh));

            fd.append("access_nivel", this.userData.access_nivel);
            fd.append("erp_code", (this.userData.erp_code || '').toUpperCase());

            fd.append("is_approver", this.userData.is_approver ? 1 : 0);
            fd.append("simplified_checklist", this.userData.simplified_checklist ? 1 : 0);
            fd.append("telemetry", this.userData.telemetry ? 1 : 0);
            fd.append("is_executive", this.userData.is_executive ? 1 : 0);
            fd.append("accept_terms", 0);

            if (this.userData.cost_center_id) {
                const costCenterId = typeof this.userData.cost_center_id === 'object'
                    ? this.userData.cost_center_id.id
                    : this.userData.cost_center_id;
                fd.append("cost_center_id", costCenterId);
            }

            if (this.shouldShowPasswordFields) {
                if (this.isEditing) {
                    if (this.userData.passwordEdit && this.userData.passwordEdit.trim() !== '') {
                        fd.append("password", this.userData.passwordEdit);
                    }
                    if (this.userData.password_confirmation && this.userData.password_confirmation.trim() !== '') {
                        fd.append("password_confirmation", this.userData.password_confirmation);
                    }
                } else {
                    fd.append("password", this.userData.password || '');
                    fd.append("password_confirmation", this.userData.password_confirmation || '');
                }
            }

            if (photo && photo.files[0]) {
                fd.append("photo", photo.files[0]);
            } else {
                fd.append("photo", "");
            }

            if (this.isEditing) {
                fd.append("id", this.userData.id);
                fd.append("_method", "PUT");
            } else {
                fd.append("_method", "POST");
            }

            return fd;
        },

        async save() {
            this.isLoading = true;
            this.errors = {};

            try {
                let api = this.$store.state.api + "users";
                const fd = this.makeFormData();

                if (this.isEditing) {
                    api += "/" + this.userData.id;
                }

                await this.$http.post(api, fd);

                const message = this.isEditing
                    ? 'Usuário atualizado com sucesso'
                    : 'Usuário cadastrado com sucesso';

                this.$message("Sucesso", message, "success");
                this.$router.push("/users");

            } catch (error) {
                console.error(error)
                if (error.response && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }

                const message = error.response && error.response.data && error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            } finally {
                this.isLoading = false;
            }
        },

        async getUser(id) {
            try {
                const api = this.$store.state.api + "users/" + id;
                const response = await this.$http.get(api);

                const user = response.data.data[0];

                this.userData = {
                    ...this.userData,
                    ...user,
                    admission_date: user.e_admission_date || '',
                    date_of_birth: user.e_date_of_birth || '',
                    validity_cnh: user.e_validity_cnh || '',
                    pri_cnh: user.e_pri_cnh || '',
                    passwordEdit: '',
                    password_confirmation: '',
                };

                if (user.cost_center_id) {
                    this.userData.cost_center_id = this.cost_centers.find(
                        center => center.id === user.cost_center_id
                    ) || user.cost_center_id;
                }

            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            }
        },

        async initializeData() {
            await this.getCostCenters();

            if (this.isEditing) {
                await this.getUser(this.$route.params.id);
            }
        }
    },
    async mounted() {
        await this.initializeData();
    },
};
</script>

<style scoped>
.content {
    padding: 20px;
}

.required_fields {
    font-size: 12px;
    float: right;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
}


/* Responsividade */
@media (max-width: 768px) {
    .content {
        padding: 10px;
    }

    .form-actions {
        flex-direction: column-reverse;
        align-items: stretch;
    }

    .required_fields {
        display: block;
        float: none;
        text-align: center;
        margin-top: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Form.vue